import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Grilla  } from './grilla.component';
import { TablaModule } from '../tabla';
import { FormularioModule  } from '../formulario';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentesService } from '../componentes.service';
import { FormDialog } from '../form-dialog/';
import { DirectivesModule } from '../directives/directives.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@NgModule({
	declarations: [
		Grilla,
		FormDialog
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatTableModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatSlideToggleModule,
		MatMenuModule,
		MatFormFieldModule,
		MatProgressSpinnerModule,
		MatBottomSheetModule,
		MatInputModule,
		MatButtonModule,
		MatSnackBarModule,
		MatIconModule,
		MatTooltipModule,
		TablaModule,
		FormularioModule,
		MatDialogModule,
		DirectivesModule
	],
	providers: [
		ComponentesService,
		{ provide: MAT_DIALOG_DATA, useValue: {} },
     	{ provide: MatDialogRef, useValue: {} }
	],
	exports: [
		Grilla,
		FormsModule,
		ReactiveFormsModule,
		FormDialog
	],
	entryComponents: [
		/** Dialogs */
		FormDialog

	],
})
export class GrillaModule { }
